import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { useTranslate } from 'lib/translate';
import { Icon } from '@haldor/ui';
import ColorScale from '_class/ColorScale';

var AssessmentDetailField = function AssessmentDetailField(props) {
  var translate = useTranslate();
  var resource = props.resource,
      row = props.row;
  /**
   * @param {object} cell
   */

  var onCellClick = function onCellClick(cell) {
    var value = [];

    if (props.input.value != null && props.input.value !== '') {
      value = props.input.value;
    }

    if (getIsCellSelected(cell)) {
      value = value.filter(function (value) {
        return value.cellId != cell.id && value.assessmentBlockPartRowId != row.id;
      });
    } else {
      var existing = getRowValue(row.id);
      value = value.filter(function (value) {
        return value.assessmentBlockPartRowId != row.id;
      });
      value.push(_objectSpread(_objectSpread({}, existing), {}, {
        cellId: cell.id,
        assessmentBlockPartRowId: row.id
      }));
    }

    props.input.onChange(value);
  };
  /**
   * @param {number} rowId
   */


  var getRowValue = function getRowValue(rowId) {
    if (props.input.value == null || props.input.value == '') {
      return null;
    }

    return props.input.value.find(function (value) {
      return value.assessmentBlockPartRowId == rowId;
    });
  };
  /**
   * @param {object} cell
   */


  var getIsCellSelected = function getIsCellSelected(cell) {
    if (props.input.value == null || props.input.value == '') {
      return false;
    }

    var foundInValue = props.input.value.find(function (value) {
      return value.cellId == cell.id && value.assessmentBlockPartRowId == row.id;
    });
    return foundInValue != null;
  };

  var getRowData = function getRowData() {
    if (row.referenceType == 'matrixRow') {
      var foundRow = null;
      var addNotAchieved = true;
      resource.value.details.forEach(function (_detail) {
        _detail.matrix._ParagraphSet.forEach(function (_paragraph) {
          var matchingRow = _paragraph.rows.find(function (_row) {
            return _row.id == row.referenceId;
          });

          if (matchingRow != null) {
            if (_detail.matrix.disableNotAchieved) {
              addNotAchieved = false;
            }

            foundRow = JSON.parse(JSON.stringify(matchingRow));
          }
        });
      });

      if (foundRow != null && addNotAchieved) {
        var _foundRow;

        if (((_foundRow = foundRow) === null || _foundRow === void 0 ? void 0 : _foundRow.cells.find(function (cell) {
          return cell.id == 'F';
        })) == null) {
          var _foundRow2;

          (_foundRow2 = foundRow) === null || _foundRow2 === void 0 ? void 0 : _foundRow2.cells.unshift({
            text: translate('Not achieved'),
            id: 'F'
          });
        }
      }

      return foundRow;
    }

    if (row.referenceType == 'assessmentGoalRow') {
      var _resource$value;

      var _foundRow3 = resource === null || resource === void 0 ? void 0 : (_resource$value = resource.value) === null || _resource$value === void 0 ? void 0 : _resource$value.rows.find(function (_row) {
        return _row.id == row.referenceId;
      });

      if (_foundRow3 != null) {
        _foundRow3.cells.sort(function (a, b) {
          return a.index - b.index;
        });
      }

      return _foundRow3;
    }
  };
  /**
   * @param {object} rowData
   */


  var getColors = function getColors(rowData) {
    var showRed = false;

    if (resource.referenceType == 'assessmentGoal') {
      showRed = rowData.cells.find(function (cell) {
        return cell.type == 'NotAchievedTextField';
      }) != null;
    }

    if (resource.referenceType == 'matrix') {
      var detail = resource.value.details.find(function (detail) {
        return detail.matrix._ParagraphSet.find(function (paragraph) {
          return paragraph.rows.find(function (row) {
            return row.id == rowData.id;
          });
        });
      });

      if (detail != null && !detail.matrix.disableNotAchieved) {
        showRed = true;
      }
    }

    return new ColorScale(rowData.cells.length).get(showRed);
  };

  var getRowParagraph = function getRowParagraph() {
    if (row.referenceType == 'matrixRow') {
      var foundParagraph = null;
      resource.value.details.forEach(function (_detail) {
        _detail.matrix._ParagraphSet.forEach(function (_paragraph) {
          var matchingRow = _paragraph.rows.find(function (_row) {
            return _row.id == row.referenceId;
          });

          if (matchingRow != null) {
            foundParagraph = _paragraph;
          }
        });
      });
      return foundParagraph;
    }

    return null;
  };
  /**
   * @param {object} cell
   * @param {number} index
   */


  var renderCell = function renderCell(cell, index) {
    var selected = getIsCellSelected(cell);
    return /*#__PURE__*/React.createElement("div", {
      className: selected ? 'cell selected' : 'cell',
      style: {
        '--level-color': colors[index]
      },
      key: cell.id,
      onClick: function onClick() {
        return onCellClick(cell);
      }
    }, row.referenceType == 'assessmentGoalRow' ? cell.value : cell.text, /*#__PURE__*/React.createElement(Icon, {
      name: "Check"
    }));
  };

  var data = getRowData();

  if (data == null) {
    return null;
  }

  var colors = getColors(data);
  var paragraph = getRowParagraph();
  return /*#__PURE__*/React.createElement(React.Fragment, null, paragraph != null && paragraph.title != null ? /*#__PURE__*/React.createElement("div", {
    className: "matrix-paragraph-title"
  }, paragraph.title) : null, paragraph != null && paragraph.subtitle != null ? /*#__PURE__*/React.createElement("div", {
    className: "matrix-paragraph-subtitle"
  }, paragraph.subtitle) : null, /*#__PURE__*/React.createElement("div", {
    className: "df row"
  }, paragraph != null ? /*#__PURE__*/React.createElement("div", null, paragraph.paragraphNr, ".", data.sentenceNr) : null, /*#__PURE__*/React.createElement("div", {
    className: "column-text"
  }, data.text != null ? data.text : data.description), /*#__PURE__*/React.createElement("div", {
    className: data.cells.length > 5 ? "cells df overflow-protection" : "cells df"
  }, data.cells.map(renderCell))));
};

export default AssessmentDetailField;